import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { me } from '@/graphql/auth.gql'
import { apolloProvider } from '@/vue-apollo'
import { guardRoutes } from '@/router-guard'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/LoginView.vue'),
    meta: {
      layout: 'centered',
      requiresGuest: true
    }
  },

  /* Admin routes */
  {
    path: '/admin',
    name: 'admin',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/AdminView.vue'),
    meta: {
      layout: 'admin',
      requiresPermission: 'admin'
    }
  },

  /* Frontend routes */
  {
    path: '/',
    name: 'frontend',
    component: () =>
      import(/* webpackChunkName: "frontend" */ '@/views/FrontendView.vue'),
    meta: {
      layout: 'frontend'
    }
  },
  {
    path: '/:page',
    name: 'page',
    component: () =>
      import(/* webpackChunkName: "frontend" */ '@/views/FrontendView.vue'),
    meta: {
      layout: 'frontend'
    }
  }
]

/* Set invalid routes to 404 */
routes.push({
  path: '*',
  name: '404',
  component: () =>
    import(/* webpackChunkName: "page404" */ '@/views/errors/404.vue'),
  meta: {
    layout: 'centered'
  }
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('auth/SET_AUTH_LOADING', true)

  apolloProvider.defaultClient
    .query({
      query: me
    })
    .then(({ data }) => {
      // store currenUser data in vuex for future use
      store.commit('auth/SET_CURRENT_USER', data.me)

      // // change frontend layout to editor if user is logged in
      // if (to.meta.layout == 'frontend' && data.me) {
      //   to.meta.layout = 'editor'
      // }

      store.commit('auth/SET_AUTH_LOADING', false)

      // start navigation guards
      guardRoutes(to, from, next)
    })
    .catch(error => {
      console.log(error)
      store.commit('auth/SET_AUTH_LOADING', false)
    })
})

export default router
